<template>
  <div class="gestao-projetos-layout">
    <aside :class="{ collapsed: menuColapsado }">
      <nav>
        <RouterLink
          :to="{ name: 'gestao-projetos.painel' }"
          :class="linkAtivo('gestao-projetos.painel')"
          :title="menuColapsado ? 'Painel' : ''"
        >
          <span class="icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="3"
                width="7"
                height="9"
                rx="1"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <rect
                x="14"
                y="3"
                width="7"
                height="5"
                rx="1"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <rect
                x="14"
                y="12"
                width="7"
                height="9"
                rx="1"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <rect
                x="3"
                y="16"
                width="7"
                height="5"
                rx="1"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
          </span>
          <span class="link-text" v-show="!menuColapsado">Painel</span>
        </RouterLink>
        <RouterLink
          :to="{ name: 'gestao-projetos.pdm' }"
          :class="linkAtivo('gestao-projetos.pdm')"
          :title="menuColapsado ? 'Planos Municipais' : ''"
        >
          <span class="icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 7V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path
                d="M3 7h18v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <path
                d="M8 11h8"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M8 15h5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="link-text" v-show="!menuColapsado"
            >Planos Municipais</span
          >
        </RouterLink>
        <RouterLink
          :to="{ name: 'gestao-projetos.projetos' }"
          :class="linkAtivo('gestao-projetos.projetos')"
          :title="menuColapsado ? 'Projetos' : ''"
        >
          <span class="icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 12l2 2 4-4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21 12c-1.39 0-2.55-1.01-2.95-2.34A3 3 0 0 0 15.66 8c-1.33-.4-2.34-1.56-2.34-2.95 0-.17 0-.34.02-.51A3 3 0 0 0 10.66 3c-1.33.4-2.34 1.56-2.34 2.95 0 .17.01.34.02.51A3 3 0 0 0 5.66 8C4.33 8.4 3.27 9.56 3 11"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M12 21a9 9 0 0 0 9-9"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="link-text" v-show="!menuColapsado">Projetos</span>
        </RouterLink>
        <RouterLink
          :to="{ name: 'gestao-projetos.relatorios' }"
          :class="linkAtivo('gestao-projetos.relatorios')"
          :title="menuColapsado ? 'Relatórios' : ''"
        >
          <span class="icon" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 20V10"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M18 20V4"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
              <path
                d="M6 20v-6"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </span>
          <span class="link-text" v-show="!menuColapsado">Relatórios</span>
        </RouterLink>
      </nav>
      <div class="menu-toggle">
        <button
          @click="toggleMenu"
          :title="menuColapsado ? 'Expandir menu' : 'Recolher menu'"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :d="menuColapsado ? 'M9 18l6-6-6-6' : 'M15 18l-6-6 6-6'"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </aside>
    <main>
      <div class="page-header">
        <svg
          class="header-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 451.971 451.971"
          fill="currentColor"
        >
          <path
            d="M172.115,288.246h-5.982l4.23-4.23c10.708-10.714,10.708-28.145,0-38.857  c-0.034-0.033-0.068-0.066-0.102-0.1c-10.721-10.615-28.078-10.581-38.76,0.099l-4.229,4.229v-5.979  c0-15.151-12.327-27.478-27.478-27.478c-15.152,0-27.479,12.326-27.479,27.478v5.978l-4.228-4.229  c-10.714-10.71-28.146-10.708-38.859,0.002c-10.711,10.713-10.712,28.146,0,38.86l4.227,4.228h-5.979  C12.326,288.246,0,300.573,0,315.724s12.326,27.478,27.478,27.478h5.979l-4.229,4.229c-10.712,10.712-10.712,28.144-0.001,38.858  c0.04,0.04,0.081,0.08,0.122,0.12C40.07,397,57.413,396.963,68.089,386.291l4.227-4.227v5.979c0,15.15,12.328,27.477,27.48,27.477  c15.15,0,27.476-12.326,27.476-27.477v-5.98l4.229,4.229c10.715,10.711,28.148,10.71,38.86-0.003  c10.712-10.713,10.712-28.145,0-38.858l-4.23-4.229h5.983c15.15,0,27.476-12.327,27.476-27.479  C199.591,300.572,187.266,288.246,172.115,288.246z M172.115,325.202h-16.089c-3.89,0-7.34,2.499-8.552,6.196  c-0.78,2.378-1.75,4.718-2.883,6.956c-1.758,3.472-1.085,7.679,1.666,10.43l11.377,11.376c3.695,3.695,3.695,9.708,0,13.403  c-3.696,3.695-9.71,3.695-13.405,0l-11.375-11.376c-2.751-2.75-6.955-3.423-10.426-1.667c-2.242,1.134-4.583,2.104-6.96,2.884  c-3.696,1.213-6.194,4.662-6.194,8.552v16.088c0,5.226-4.252,9.477-9.478,9.477c-5.227,0-9.479-4.251-9.479-9.477v-16.089  c0-3.889-2.497-7.337-6.191-8.551c-2.381-0.782-4.723-1.752-6.961-2.885c-1.29-0.652-2.68-0.969-4.06-0.969  c-2.334,0-4.638,0.907-6.366,2.636l-11.375,11.375c-3.696,3.695-9.71,3.697-13.405,0.001c-0.023-0.022-0.045-0.045-0.068-0.067  c-3.628-3.702-3.606-9.664,0.066-13.336l11.378-11.379c2.751-2.752,3.423-6.961,1.664-10.432c-1.125-2.222-2.096-4.563-2.883-6.957  c-1.214-3.693-4.662-6.189-8.55-6.189H27.478c-5.226,0-9.478-4.253-9.478-9.479c0-5.226,4.251-9.477,9.478-9.477h16.088  c3.886,0,7.333-2.494,8.549-6.186c0.787-2.391,1.758-4.733,2.887-6.963c1.756-3.471,1.084-7.678-1.666-10.428l-11.376-11.378  c-3.696-3.696-3.696-9.711-0.001-13.406c3.696-3.692,9.708-3.694,13.403,0l11.378,11.379c2.751,2.751,6.958,3.424,10.43,1.665  c2.226-1.127,4.567-2.097,6.958-2.883c3.693-1.214,6.189-4.662,6.189-8.55v-16.09c0-5.226,4.253-9.478,9.48-9.478  c5.225,0,9.476,4.252,9.476,9.478v16.088c0,3.888,2.496,7.336,6.189,8.55c2.383,0.783,4.725,1.755,6.96,2.886  c3.47,1.755,7.677,1.086,10.428-1.666l11.379-11.379c3.697-3.694,9.709-3.696,13.403-0.002c0.019,0.02,0.038,0.038,0.057,0.057  c3.639,3.7,3.621,9.673-0.055,13.349l-11.377,11.378c-2.751,2.752-3.422,6.959-1.665,10.43c1.129,2.23,2.1,4.572,2.885,6.96  c1.214,3.693,4.662,6.189,8.55,6.189h16.089c5.225,0,9.476,4.252,9.476,9.479C181.591,320.95,177.34,325.202,172.115,325.202z   M376.944,239.559c-4.971,0-9-4.029-9-9V127.182c0-4.123-3.354-7.477-7.476-7.477H343.99c-4.971,0-9-4.029-9-9s4.029-9,9-9h16.478  c14.047,0,25.476,11.429,25.476,25.477v103.377C385.944,235.53,381.915,239.559,376.944,239.559z M99.797,285.976  c-16.404,0-29.75,13.346-29.75,29.75c0,16.403,13.346,29.749,29.75,29.749c16.404,0,29.749-13.346,29.749-29.749  C129.546,299.322,116.201,285.976,99.797,285.976z M99.797,327.475c-6.479,0-11.75-5.271-11.75-11.749s5.271-11.75,11.75-11.75  c6.479,0,11.749,5.271,11.749,11.75S106.275,327.475,99.797,327.475z M297.979,7.686h-57.14c-4.971,0-9,4.029-9,9v378.693  c0,4.971,4.029,9,9,9h57.14c4.971,0,9-4.029,9-9V16.686C306.979,11.715,302.95,7.686,297.979,7.686z M288.979,386.379h-39.14  v-45.117h12.125c4.971,0,9-4.029,9-9s-4.029-9-9-9h-12.125v-45.115h12.125c4.971,0,9-4.029,9-9s-4.029-9-9-9h-12.125v-45.114h12.125  c4.971,0,9-4.029,9-9s-4.029-9-9-9h-12.125v-45.115h12.125c4.971,0,9-4.029,9-9s-4.029-9-9-9h-12.125V88.802h12.125  c4.971,0,9-4.029,9-9s-4.029-9-9-9h-12.125V25.686h39.14V386.379z M451.971,44.218v323.627c0,4.971-4.029,9-9,9h-52.144  c-4.971,0-9-4.029-9-9s4.029-9,9-9h43.144V53.218h-94.12c-4.971,0-9-4.029-9-9s4.029-9,9-9h103.12  C447.941,35.218,451.971,39.248,451.971,44.218z M352.99,433.69v1.595c0,4.971-4.029,9-9,9s-9-4.029-9-9v-1.595c0-4.971,4.029-9,9-9  S352.99,428.719,352.99,433.69z M352.99,143.575v260.952c0,4.971-4.029,9-9,9s-9-4.029-9-9V143.575c0-4.971,4.029-9,9-9  S352.99,138.604,352.99,143.575z M201.84,35.218c0,0-79.909,0.003-80.092,0.013c-2.004,0.104-3.834,0.863-5.281,2.067  c-0.001,0.001-0.003,0.003-0.005,0.004c-0.004,0.004-0.009,0.008-0.013,0.011c-0.004,0.004-0.008,0.007-0.012,0.01  c-0.002,0.002-0.004,0.004-0.006,0.005c-0.005,0.005-0.011,0.01-0.017,0.015l0,0.001c-0.191,0.161-81.112,81.067-81.112,81.067  c-1.553,1.549-2.543,3.661-2.638,6.005c-0.006,0.145-0.007,75.528-0.007,75.528c0,4.971,4.029,9,9,9s9-4.029,9-9v-66.16h71.565  c4.971,0,9-4.029,9-9V53.218h70.618c4.971,0,9-4.029,9-9S206.811,35.218,201.84,35.218z M113.223,115.784H63.386l49.837-49.838  V115.784z"
          />
        </svg>
        <h1 class="page-title">Gestão de Projetos</h1>
      </div>
      <div class="main-surface">
        <RouterView />
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "LayoutGestaoProjetos",
  data() {
    return {
      menuColapsado: false,
    };
  },
  methods: {
    linkAtivo(nomeRota) {
      if (!this.$route.name) return "";
      if (
        nomeRota === "gestao-projetos.projetos" &&
        this.$route.name.startsWith("gestao-projetos.mensuracao")
      ) {
        return "ativo";
      }
      return this.$route.name.startsWith(nomeRota) ? "ativo" : "";
    },
    toggleMenu() {
      this.menuColapsado = !this.menuColapsado;
    },
  },
};
</script>

<style scoped lang="scss">
.gestao-projetos-layout {
  display: grid;
  grid-template-columns: minmax(240px, 280px) minmax(0, 1fr);
  min-height: calc(100vh - 80px);
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
  transition: grid-template-columns 0.3s ease;
}

.gestao-projetos-layout:has(.collapsed) {
  grid-template-columns: 80px minmax(0, 1fr);
}

aside {
  background: #004b87;
  color: #f8fafc;
  padding: 0;
  display: flex;
  flex-direction: column;
  border-right: none;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  width: 100%;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
}

aside.collapsed {
  align-items: center;
}

aside.collapsed .brand-panel {
  align-items: center;
}

aside.collapsed .brand-badge {
  writing-mode: vertical-lr;
  font-size: 0.6rem;
  padding: 8px 4px;
  letter-spacing: 0.05em;
}

.brand-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  z-index: 1;
}

.brand-badge {
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  transition: all 0.3s ease;
}

nav {
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
  z-index: 1;
  flex: 1;
  padding: 20px 0 100px 0;
}

a {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  border-radius: 0;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.2s ease;
  min-height: 56px;
  justify-content: flex-start;
}

aside.collapsed a {
  justify-content: center;
  padding: 16px;
  gap: 0;
}

aside.collapsed a .icon {
  margin: 0;
}

a:hover,
a:focus {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

aside.collapsed a:hover,
aside.collapsed a:focus {
  background: rgba(255, 255, 255, 0.1);
}

a.ativo {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.08) 100%
  );
  border-left: 4px solid #0074cc;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);

  .link-text {
    color: #ffffff;
    font-weight: 600;
  }

  .icon {
    background: #ff6b35;
    color: #ffffff;
    box-shadow: 0 2px 8px rgba(0, 116, 204, 0.3);
  }
}

.icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.link-text {
  font-size: 1rem;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.02em;
  color: #f0f9ff;
}

.menu-toggle {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 20px;
  border-top: 1px solid rgb(255 255 255 / 17%);
  background: linear-gradient(
    180deg,
    rgba(0, 75, 135, 0.9) 0%,
    rgba(0, 51, 102, 1) 100%
  );
  backdrop-filter: blur(10px);
}

.menu-toggle button {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0 auto;
}

.menu-toggle button:hover {
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
}

.menu-toggle button svg {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

main {
  min-width: 0;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding: 16px 24px;
  border: 1px solid rgba(0, 116, 204, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.header-icon {
  width: 40px;
  height: 40px;
  color: #004b87;
}

.page-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #004b87;
  letter-spacing: 0.01em;
}

.main-surface {
  max-width: 1280px;
  width: 100%;

  padding: 0px 30px;
}

@media (max-width: 1100px) {
  .gestao-projetos-layout {
    grid-template-columns: minmax(220px, 260px) minmax(0, 1fr);
  }

  .gestao-projetos-layout:has(.collapsed) {
    grid-template-columns: 70px minmax(0, 1fr);
  }
}

@media (max-width: 980px) {
  .gestao-projetos-layout {
    grid-template-columns: 1fr !important;
    grid-template-rows: auto 1fr;
  }

  aside {
    border-right: none;
    border-bottom: 1px solid rgba(226, 232, 240, 0.4);
    padding: 24px 22px 18px;
    position: sticky;
    top: 80px;
    z-index: 9;
  }

  aside.collapsed {
    padding: 24px 22px 18px;
  }

  .brand-panel {
    display: none;
  }

  nav {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  aside.collapsed nav {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  a {
    flex: 1 1 calc(50% - 12px);
  }

  aside.collapsed a {
    flex: 0 0 auto;
    min-width: 60px;
    justify-content: center;
  }

  .menu-toggle {
    display: none;
  }

  main {
    padding: 26px 22px 36px;
  }

  .main-surface {
    background: rgba(255, 255, 255, 0.94);
  }
}

@media (max-width: 720px) {
  nav {
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 4px;
  }

  a {
    flex: 0 0 auto;
    min-width: 220px;
  }

  aside.collapsed a {
    min-width: 60px;
  }

  main {
    padding: 22px 18px 30px;
  }

  .main-surface {
    border-radius: 20px;
    padding: 22px;
  }
}

@media (max-width: 520px) {
  aside {
    padding: 20px 18px 16px;
  }

  aside.collapsed {
    padding: 20px 18px 16px;
  }

  main {
    padding: 18px 16px 28px;
  }

  .main-surface {
    padding: 20px;
  }
}
</style>
